"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredSpinner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const design_system_1 = require("@servicetitan/design-system");
const CenteredSpinner = ({ size, className, info, }) => {
    return (jsx_runtime_1.jsxs(design_system_1.Stack, Object.assign({ justifyContent: "center", alignItems: "center", direction: "column", className: classnames_1.default(className, 'h-100 w-100') }, { children: [jsx_runtime_1.jsx(design_system_1.Spinner, { className: "of-hidden", size: size }, void 0), !!info && (jsx_runtime_1.jsx(design_system_1.BodyText, Object.assign({ size: "small", className: "m-t-1", subdued: true }, { children: info }), void 0))] }), void 0));
};
exports.CenteredSpinner = CenteredSpinner;
//# sourceMappingURL=centered-spinner.js.map